import OwnerRegistrationForm from 'components/authenitcation/registration/OwnerRegistrationForm';
import AuthContext from 'context/authContext';
import { useMemo, useContext } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import ChangePassword from './ChangePassword';
import TwoFactorAuth from './TwoFactorAuth';
import { useUpdateUser } from 'hooks/useUsers';

export default function PersonalSettings() {
  const { user, initializeUser } = useContext(AuthContext);
  const { updateUserAsync, isUpdating } = useUpdateUser();

  const onSubmit = async ({
    title,
    firstName,
    lastName,
    phoneNumber,
    email
  }) => {
    try {
      await updateUserAsync({
        id: user.id,
        data: {
          title,
          first_name: firstName,
          last_name: lastName,
          phone: phoneNumber,
          email
        }
      });

      // Refresh user data from database to show updated info
      await initializeUser();
    } catch (error) {
      console.error('Update profile error:', error);
    }
  };

  const initialValues = useMemo(() => {
    if (user) {
      const {
        title,
        first_name: firstName,
        last_name: lastName,
        phone,
        email
      } = user;
      return {
        title,
        firstName,
        lastName,
        phoneNumber: phone,
        confirmPhoneNumber: phone,
        email
      };
    }
    return {};
  }, [user]);

  return !user ? (
    <div className="d-flex justify-content-center">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  ) : (
    <Container fluid className="px-0">
      <Row>
        <Col sm={12} md={7} className="d-flex flex-column gap-3">
          <Card>
            <Card.Header>
              <h4>Personal Settings</h4>
            </Card.Header>
            <Card.Body>
              <OwnerRegistrationForm
                loading={isUpdating}
                onSubmit={onSubmit}
                initialValues={initialValues}
                isEdit
              />
            </Card.Body>
          </Card>
          <Card>
            <Card.Header>
              <h4>Change Password</h4>
            </Card.Header>
            <Card.Body>
              <ChangePassword />
            </Card.Body>
          </Card>
          <Card>
            <Card.Header>
              <h4>Two-Factor Authentication</h4>
            </Card.Header>
            <Card.Body>
              <TwoFactorAuth />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
